import React, {useEffect} from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import {useNavigate} from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import {getStoreConfig, getStoreConfigLoyalty, getStoreDefaultConfig} from "../../services/Store/reducer";
import Footer from "../../components/layout/Footer/Footer";
import HomePageMenusComponent from "./components/Menus/HomePageMenusComponent";
import AdvertUserComponent from "../../components/User/components/AdvertUser";
import UserUtils from "../../services/User/UserUtils";
import {getUser} from "../../services/User/reducer";
import {getLanguagesBasedOnStoreType} from "../../services/languageUtils";
import {getSession} from "../../services/Session/reducer";
import AppConfig from "../../services/AppConfig";
import {usePrefix} from "../../services/Prefix";
import Hero from "../../components/Common/Hero";
import StoreUtils from "../../services/Store/StoreUtils";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const HomePage = ({config, session, config_loyalty, user, default_config}: Props) => {
    const navigate = useNavigate();
    const tableNumber = session.table_number;
    const prefix = usePrefix();
    const qrCodeContext = StoreUtils.isQrcodeContext(session);

    useEffect(() => {
        init();
    }, [tableNumber]);

    const init = () => {
        if (qrCodeContext && !tableNumber) {
            navigate(AppConfig.getLinkWithPrefix('/menu', prefix), {replace: true});
        }
    }

    return (
        <div className={`home-page ${qrCodeContext ? "home-page--qrcode-context" : ""}`}>
            {(UserUtils.isLoyaltyRegistration(config_loyalty) && (!user || !user.name)) && (
                <AdvertUserComponent/>
            )}
            <Navbar withoutBackComponents/>
            <div className="inner-container">
                <Hero config={config} places={[]}
                      onButtonClick={() => navigate(AppConfig.getLinkWithPrefix('/menu', prefix))}/>
                {StoreUtils.isQrcodeContext(session) && <HomePageMenusComponent/>}
                <Footer config={config} languages={getLanguagesBasedOnStoreType(default_config)}/>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    default_config: getStoreDefaultConfig(state.config),
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(HomePage);